import { Draggable } from 'react-beautiful-dnd';
import React from 'react';
import PropTypes from 'prop-types';

const DraggableItem = props => (
  <Draggable key={props.name} {...props}>
    {(provided, snapshot) => (
      <div
        className={props.className}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={props.style(snapshot.isDragging, provided.draggableProps.style)}
      >
        {props.children}
      </div>
    )}
  </Draggable>
);

DraggableItem.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  draggableId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDragDisabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  style: PropTypes.func
};

DraggableItem.defaultProps = {
  className: '',
  isDragDisabled: false,
  style: (isDragging, draggableStyle) => ({
    userSelect: 'none',
    flexGrow: 1,
    opacity: 1,
    background: '#fff',
    flexBasis: 0,
    ...draggableStyle
  })
};

export default DraggableItem;
